import * as React from 'react';

/**
 * @internal
 */

const FormControlContext = /*#__PURE__*/React.createContext(undefined);
export default FormControlContext;